import Vue from 'vue'
import {
  UserManagerSettings,
  Log,
  Logger,
  User,
  UserManager,
  Profile,
  WebStorageStateStore,
  UserManagerEvents
} from 'oidc-client'

const environment = {
  production: false,
  stsAuthority: `${process.env.VUE_APP_EZID_BASE_URL}`,
  clientId: '5sClient',
  clientRoot: location.origin,
  clientScope: 'email 5star profile roles openid',
  apiRoot: `${process.env.VUE_APP_EZID_BASE_URL}`,
};

const idsrvAuth = new UserManager(
  {
    authority: environment.stsAuthority,
    client_id: environment.clientId,
    redirect_uri: `${environment.clientRoot}/login`,
    post_logout_redirect_uri: `${environment.clientRoot}/logout`,
    response_type: 'id_token token',
    scope: environment.clientScope
  }
)

// a little something extra
Vue.prototype.$oidc = idsrvAuth

export default idsrvAuth